import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../admin.service';
import { confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-users-list',
  standalone: false,
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.css']
})
export class UsersListComponent implements OnInit {
  users: any[] = [];
  loading = false;

  constructor(
    private admin: AdminService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.admin.getUsers().subscribe(users => {
      this.users = users || [];
      this.loading = false;
    }, () => {
      this.loading = false;
      notify('Unable to load users', 'error', 2500);
    });
  }

  onToolbarPreparing(e: any): void {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: { icon: 'plus', text: 'Add User', type: 'default', onClick: () => this.onAdd() }
    });
  }

  onAdd(): void {
    this.router.navigate(['/admin/users/new']);
  }

  // Bound as arrow properties so `this` resolves inside dx grid button callbacks.
  onEditClick = (e: any): void => { this.router.navigate(['/admin/users', e.row.data.id]); };

  onDeleteClick = (e: any): void => {
    const user = e.row.data;
    confirm(`Delete user "${user.name}"? This cannot be undone.`, 'Confirm delete').then(ok => {
      if (!ok) { return; }
      this.admin.deleteUser(user.id).subscribe(() => {
        notify('User deleted', 'success', 2000);
        this.load();
      }, err => {
        notify(err?.error?.message || 'Unable to delete user', 'error', 2500);
      });
    });
  };
}
